import { memo } from 'react';
import { EApplicationPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';
import { Flex } from '@chakra-ui/react';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {cellProps.row.applicationStatus || cellProps.row.status || UNKNOWN_VALUE}
    </Flex>
  );
});

export const StatusColumn = (): IColumn => ({
  item: {
    key: EApplicationPGKeys.STATUS,
    name: 'Status',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
